
/**
 * 프로젝트 공개 설정
 */
export type SaveProjectBodyMetadataVisibility = typeof SaveProjectBodyMetadataVisibility[keyof typeof SaveProjectBodyMetadataVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SaveProjectBodyMetadataVisibility = {
  public: 'public',
  private: 'private',
  unlisted: 'unlisted',
} as const;
